import { formatToCNPJ } from 'brazilian-values'
import React from 'react'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayActivities(props) {
  const { questionData } = props
  const classes = styles()

  const buildActivity = (activityInfo) => {
    return (
      <div className={classes.answersContainer} key={activityInfo.key}>
        <p>
          <span>Razão social: </span>
          {activityInfo?.corporate_name}
        </p>
        <p>
          <span>CNPJ: </span>
          {activityInfo?.cnpj ? formatToCNPJ(activityInfo?.cnpj) : 'N/A'}
        </p>

        <p>
          <span>Cargo: </span>
          {activityInfo?.role}
        </p>
        <p>
          <span>Atividades desenvolvidas: </span>
          {activityInfo?.developed_activities}
        </p>
        {typeof activityInfo?.will_keep_role === 'boolean' && (
          <p>
            <span>Continuará desempenhando atividade? </span>
            {activityInfo?.will_keep_role ? 'Sim' : 'Não'}
          </p>
        )}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento das Atividades:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não possui atividades deste tipo."
        funcBuildItem={buildActivity}
      />
    </div>
  )
}

export default DisplayActivities
